import { gql } from "@apollo/client";

export interface LCTerminal {
	deviceId: number
	port: number
	parentDeviceId: number
	parentPort: number
	nextDeviceId: number
	nextPort: number
	terminalType: number
	timeAct: number
	val1_min: number
	val1_max: number
	val1_type: number
	val2_type: number
	val2_min: number
	val2_max: number
	extra: number
	programmed: number
	sensor_p: number
	consumptionDeviceId: number
	consumptionPort: number
	correction: number
	limit: number
	activations: number
	periodecomp: number
	extra_pause: number
	last_run?: number
	milestoneId: number
	feedcurveId: number
	milestoneDay?: number
	componentId: number
	skipCnt: number
	skipTime?: number
}


export const LC_TERMINAL = gql`
query GetLCTerminal($domain: String!, $lanControllerId: Int!) {
	controller {
		lcTerminal(domain: $domain, lanControllerId: $lanControllerId) {
			deviceId
			port
			parentDeviceId
			parentPort
			nextDeviceId
			nextPort
			terminalType
			timeAct
			val1_min
			val1_max
			val1_type
			val2_type
			val2_min
			val2_max
			extra
			programmed
			sensor_p
			consumptionDeviceId
			consumptionPort
			correction
			limit
			activations
			periodecomp
			extra_pause
			last_run
			milestoneId
			feedcurveId
			milestoneDay
			componentId
			skipCnt
			skipTime
		}
	}
}
`

export interface LCTerminalResponse {
	controller: {
		lcTerminal: LCTerminal[] | null
	}
}

export interface LCTerminalArgs {
	domain: string;
	lanControllerId: number;
}

